// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#pianifica-navbar[data-v-38a363ae]{width:100%}@media screen and (min-width:1280px){#pianifica-navbar .border-x-custom[data-v-38a363ae]{border-color:#d1d5db;border-style:solid;border-width:0 1px}#pianifica-navbar .min-w-custom[data-v-38a363ae]{min-width:224px;max-width:224px}}#pianifica-navbar .py-1px[data-v-38a363ae]{padding-top:1px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
